export default __webpack_public_path__ + "static/media/bmi.7719578c.png";